import "./PlantationOneFooter.scss";
import {
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaLinkedinIn,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import { useDocument } from "../../../../firebase-files/hooks/useDocument";

const PlantationOneFooter = () => {
  const { document: socialDoc } = useDocument("settings", "socialmedia");
  const { document: orgDoc } = useDocument("settings", "organisation");

  const socialLinks = socialDoc?.socialmedia || {};
  const organizationShortName = orgDoc?.short_name || "Organization";

  // Get the current year
  const currentYear = new Date().getFullYear();

  // Enhanced validation function
  const isValidSocialLink = (url) => {
    return (
      url &&
      typeof url === "string" &&
      url !== "#" &&
      (url.startsWith("http://") || url.startsWith("https://"))
    );
  };

  const socialPlatforms = [
    { key: "facebook", icon: <FaFacebookF />, label: "Facebook" },
    { key: "twitter", icon: <FaTwitter />, label: "Twitter" },
    { key: "instagram", icon: <FaInstagram />, label: "Instagram" },
    { key: "linkedin", icon: <FaLinkedinIn />, label: "LinkedIn" },
  ];

  return (
    <footer className="plantation-footer">
      <div className="nature-container">
        <div className="footer-grid">
          {/* Logo and Description Column */}
          <div className="footer-column footer-about">
            <h3 className="footer-logo">{organizationShortName}</h3>
            <p className="nature-text">
              Dedicated to creating a greener planet through reforestation,
              education, and community.
            </p>

            <div className="footer-social">
              {socialPlatforms.map(
                (platform) =>
                  socialLinks[platform.key] &&
                  isValidSocialLink(socialLinks[platform.key]) && (
                    <a
                      key={platform.key}
                      href={socialLinks[platform.key]}
                      className="social-icon"
                      aria-label={platform.label}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {platform.icon}
                    </a>
                  )
              )}
            </div>
          </div>

          {/* Quick Links Column */}
          <div className="footer-column">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-links">
              <li>
                <Link to="/" className="footer-link">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/aboutus" className="footer-link">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="footer-link">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/products-two" className="footer-link">
                  Adopt Trees
                </Link>
              </li>
            </ul>
          </div>

          {/* Tree Categories Column */}
          <div className="footer-column">
            <h4 className="footer-heading">Plant Categories</h4>
            <ul className="footer-links">
              <li>
                <Link
                  to="/products?category=medicinal%20%26%20healing%20trees"
                  className="footer-link"
                >
                  Medicinal Trees
                </Link>
              </li>
              <li>
                <Link
                  to="/products?category=fruits%20trees"
                  className="footer-link"
                >
                  Fruit Trees
                </Link>
              </li>
              <li>
                <Link
                  to="/products?category=shade%20trees"
                  className="footer-link"
                >
                  Shade Trees
                </Link>
              </li>
            </ul>
          </div>

          {/* Purpose Column */}
          <div className="footer-column">
            <h4 className="footer-heading">Purpose To Adopt</h4>
            <ul className="footer-links">
              <li>
                <Link to="/products-two" className="footer-link">
                  Memory of a Loved-one
                </Link>
              </li>
              <li>
                <Link to="/products-two" className="footer-link">
                  Celebrating Milestones
                </Link>
              </li>
              <li>
                <Link to="/products-two" className="footer-link">
                  Legacy and Future Generations
                </Link>
              </li>
              <li>
                <Link to="/products-two" className="footer-link">
                  Community Building
                </Link>
              </li>
              <li>
                <Link to="/products-two" className="footer-link">
                  Aesthetic Value
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Legal Links Section */}
        <div className="footer-legal">
          <Link to="/privacy-policy" className="legal-link">
            Privacy Policy
          </Link>
          <Link to="/term-condition" className="legal-link">
            Terms & Conditions
          </Link>
          <Link to="/page/NMD77NC0RnhYL7SgfuQo" className="legal-link">
            Cancellation & Refund
          </Link>
          <Link to="/page/kXC257NyjY9hciHkUZqL" className="legal-link">
            Disclaimer
          </Link>
        </div>

        {/* Footer Bottom Section */}
        <div className="plantation-one-footer-bottom">
          &copy; {currentYear} {document && document.full_name}. All rights
          reserved
          <br />
          <a
            href="https://www.hyperclouddigital.com/"
            target="_blank"
            style={{ color: "white" }}
          >
            {document && document.copyRightArea ? (
              document.copyRightArea.trim() !== "" ? (
                <>{document.copyRightArea}</>
              ) : (
                <>
                  Design & Developed by
                  <br />
                  Hyper Cloud Digital Solutions
                </>
              )
            ) : (
              <>
                Design & Developed by
                <br />
                Hyper Cloud Digital Solutions
              </>
            )}
          </a>
        </div>

        {/* <div className="footer-bottom">
          <div className="footer-copyright">
            &copy; {new Date().getFullYear()} {organizationFullName}. All Rights Reserved.
          </div>
          <div className="footer-design">
            {copyRightArea.trim() !== "" ? (
              <span dangerouslySetInnerHTML={{ __html: copyRightArea }} />
            ) : (
              <>
                Designed & Developed by
                <br />
                HyperCloud
              </>
            )}
          </div>
        </div> */}
      </div>
    </footer>
  );
};

export default PlantationOneFooter;
